import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import SelectSimplePoloPetroquimico from './SelectSimplePoloPetroquimico.js';

import { Label, Input, FormFeedback } from 'reactstrap';

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rubro_id: null,
            pais_id: null,
            clasificacion_id: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    setSelects(data) {
        this.setState({
            rubro_id: data.rubro_id,
            pais_id: data.pais_id,
            clasificacion_id: data.clasificacion_id,
            polo_petroquimico: data.polo_petroquimico,
        });
    }

    render() {
        const { polo_petroquimico } = this.state;

        return (
            <ParadigmaModal
                getUrl={api.clientes.empresas.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Empresa"}
                buttonTitle={"Ver Empresa"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                onGotData={(data) => this.setSelects(data)}
                className={"ui-modal-dialog ui-modal-lg"}>
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Nombre</Label>
                                    <Input type="text" name="nombre" disabled={true}></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Razón Social</Label>
                                    <Input type="text" name="razonSocial" disabled={true}></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>CUIT</Label>
                                    <Input type="text" name="cuit" disabled={true}></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Clasificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Clasificación</Label>
                                    <ParadigmaAsyncSeeker fieldName={"clasificacion_id"} value={this.state.clasificacion_id} url={api.clientes.clasificacion.select} disabled={true} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Rubro</Label>
                                    <ParadigmaAsyncSeeker fieldName={"rubro_id"} value={this.state.rubro_id} url={api.clientes.rubros.select} disabled={true} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Polo Petroquímico</Label>
                                    <SelectSimplePoloPetroquimico value={polo_petroquimico} disabled={true} />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Contacto</p>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Email</Label>
                                    <Input type="text" name="email" disabled={true}></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Teléfono</Label>
                                    <Input type="text" name="telefono" disabled={true}></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>País</Label>
                                    <ParadigmaAsyncSeeker fieldName={"pais_id"} url={api.misc.paises.select} value={this.state.pais_id} disabled={true} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block ui-section-compact">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input type="textarea" name="observaciones" disabled={true} rows="5"/>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/clientes/Empresas/Detail.js